'use client';

import { Box } from '@skin-seoul/design-system';
import { LoyaltyPointsSignUpBannerDesktop } from './LoyaltyPointsSignUpBanner.Desktop';
import { LoyaltyPointsSignUpBannerMobile } from './LoyaltyPointsSignUpBanner.Mobile';
export const LoyaltyPointsSignUpBanner = () => {
  return <>
      {/* Mobile View - Below tablet breakpoint (768px) */}
      <Box width="100%" hideFrom="tablet" data-sentry-element="Box" data-sentry-source-file="LoyaltyPointsSignUpBanner.tsx">
        <LoyaltyPointsSignUpBannerMobile data-sentry-element="LoyaltyPointsSignUpBannerMobile" data-sentry-source-file="LoyaltyPointsSignUpBanner.tsx" />
      </Box>

      {/* Desktop View - Above tablet breakpoint */}
      <Box width="100%" hideBelow="tablet" data-sentry-element="Box" data-sentry-source-file="LoyaltyPointsSignUpBanner.tsx">
        <LoyaltyPointsSignUpBannerDesktop data-sentry-element="LoyaltyPointsSignUpBannerDesktop" data-sentry-source-file="LoyaltyPointsSignUpBanner.tsx" />
      </Box>
    </>;
};